import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface ProductReviewInput {
  product_id: GQL_ID
  rating: number
  comment: string
  images: GQL_ID[]
}

interface SaveProductReviewVariables {
  newData: ProductReviewInput
  upsert: boolean
}

interface SaveProductReviewData {
  saveProductReview: {
    id: GQL_ID
    rating: number
    comment: string
    status: number
    customer_id: GQL_ID
    images: {
      url: string
    }[]
  }
}

export const GQL_MUTATION_SAVE_PRODUCT_REVIEW = gql`
  mutation saveProductReview($newData: ProductReviewInput, $upsert: Boolean) {
    saveProductReview(newData: $newData, upsert: $upsert) {
      id
      status
      customer_id
      images {
        url
      }
    }
  }
`

export const useSaveProductReview = () =>
  useMutation<SaveProductReviewData, SaveProductReviewVariables>(
    GQL_MUTATION_SAVE_PRODUCT_REVIEW
  )
